import React, { useEffect, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap'
import * as Icons from "react-feather";
import ViewClient from './ViewClient';
import EditClient from './EditClient';
import ClientModel, { AddressModel } from './models/ClientModel';
import DeleteClient from './DeleteClient';
import AddClient from './AddClient';
import ImportClientExcel from './ImportClientExcel';
import { logAuditEvent } from '../../utils/auditLogger';

function ClientModal({onClose, onSubmit, UserAction, show, selectedRow, displayModule, isImporting, resetFileCounter}) {
    const [childData, setChildData] = useState(new ClientModel() || []);
    const [childAddressData, setChildAddressData] = useState(new AddressModel() || []);
    const [isInitialized, setIsInitialized] = useState(false);
    let modalAction;
    let showButtons;
    useEffect(() => {
      if (show && selectedRow) {
        // Reset client data
        setChildData({ ...selectedRow });
    
        // Reset address data safely (check if it exists)
        if (selectedRow.Address && selectedRow.Address.length > 0) {
          setChildAddressData({ ...selectedRow.Address[0] });
        } else {
          setChildAddressData(new AddressModel());
        }
        setIsInitialized(true); 
      } else if (!show) {
        // When modal closes, reset everything
        setChildData(new ClientModel());
        setChildAddressData(new AddressModel());
        setIsInitialized(false);
      }
    }, [selectedRow, show]);
    

    const handleDataFromChild = (data) => {
        setChildData(data);
    };

    const handleAddressDataFromChild = (data) => {
        setChildAddressData(data);
    };

    const handleCancel = (label) => {
        onClose();
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if(childData){
            childData.Address = [childAddressData];
        }
        onSubmit(e, childData);  // Send the form data back to the parent component
    };

    const handleLoad = (data) => {
        setChildData(data); // Send the form data back to the parent component
    };
    if(UserAction === "Add"){
        modalAction = <AddClient 
                        onLoad= {handleLoad}
                        sendDataToParent={handleDataFromChild}
                        sendAddressDataToParent={handleAddressDataFromChild} 

                    />
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="Add" onClick={onClose}>Cancel</button>
                            <button className="btn btn-submit" name="Add" onClick={handleSubmit}> Submit </button>
                    </div>
    } else if(UserAction === "Edit"){
        modalAction = isInitialized ? (
            <EditClient
              key={childData?.ClientId || "new"}
              ClientData={childData}
              ClientAddressData={childAddressData}
              onSubmit={onSubmit}
              sendAddressDataToParent={handleAddressDataFromChild}
              sendDataToParent={handleDataFromChild}
            />
          ) : (
            <div className="text-center p-3">Loading client details...</div> // simple fallback
          );
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="Edit" onClick={onClose}>Cancel</button>
                            <button className="btn btn-submit" name="Edit" onClick={handleSubmit}> Submit </button>
                    </div>
    } else if(UserAction === "View"){
        modalAction = <ViewClient ClientData={selectedRow}/>
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="View" onClick={onClose}>Cancel</button>
                    </div>
    } else if(UserAction === "Delete"){
        modalAction = <DeleteClient ClientData={childData.ClientId ? childData : selectedRow}/>
        showButtons = <div>
                            <button className="btn btn-sm btn-secondary m-1" name="Delete" onClick={onClose}>Cancel</button>
                            <button className="btn btn-sm btn-danger m-1" name="Delete" onClick={handleSubmit}>Delete</button>
                    </div>
    } else if(UserAction === "Import") {
        const logs = selectedRow && selectedRow.logs ? selectedRow.logs : [];
        modalAction = <ImportClientExcel sendDataToParent={handleDataFromChild} logs={logs} resetFile={resetFileCounter} />
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="Import" onClick={onClose}>Cancel</button>
                            <button className="btn btn-submit" name="Import" onClick={handleSubmit}>Import</button>
                    </div>
    }
  return (
    UserAction !== "Delete" ?
            <Modal 
                show={show}
                onHide={onClose}
                backdrop="static"
                dialogClassName="add-centered"
            >
                { isImporting &&  (
                        <div id="global-loader" style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: 'rgba(255, 255, 255, 0.7)',
                            zIndex: 10,
                            borderRadius: 'inherit',
                            height:'100%'
                        }}>
                            <div className="whirly-loader"> </div>
                        </div>
                    )}
                <ModalHeader className="modal-header border-1 custom-modal-header" >
                    <ModalTitle >{UserAction + " " + displayModule}</ModalTitle>
                    <button type="button" className="close" aria-label="Close" onClick={() => handleCancel('Close')}>
                        <span aria-hidden="true">×</span>
                    </button>
                </ModalHeader>
                <ModalBody style={{ position: 'relative', minHeight: isImporting ? '200px' : 'auto' }}>
                    
                    {modalAction}
                </ModalBody>
                <ModalFooter className="">
                    {showButtons}
                </ModalFooter>
            </Modal> 
        :   <Modal 
                show={show}
                onHide={onClose}
                backdrop="static"            >
           
                <ModalHeader className="alert custom-alert1 alert-danger modalheader-width">
                    <ModalTitle>
                        <div className="custom-alert-icon">
                            <Icons.AlertOctagon className="flex-shrink-0"/>
                        </div>
                        <div >{UserAction + " " + displayModule}</div>
                    </ModalTitle>
                </ModalHeader>
                
                <ModalBody>
                    {modalAction}
                </ModalBody>
                <ModalFooter className="modalfooter-width">
                    {showButtons}
                </ModalFooter>
            </Modal>  
  )
}

export default ClientModal